export const earningHistoryState = () => ({
  startDate: null,
  endDate: null,
  page: 1,
  perPage: 10,
  searchKey: "",
});
